export const allFunds = (state) => state.funds

export const cashFunds = (state) => state.funds.filter(fund => fund.type === 'Efectivo')

export const bankFunds = (state) => state.funds.filter(fund => fund.type === 'Banco')

export const isLoaded = (state) => state.loaded
